import { render } from "./furniturreComponent.vue?vue&type=template&id=2bbc3c2d&scoped=true"
import script from "./furniturreComponent.vue?vue&type=script&lang=js"
export * from "./furniturreComponent.vue?vue&type=script&lang=js"

import "./furniturreComponent.vue?vue&type=style&index=0&id=2bbc3c2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbc3c2d"]])

export default __exports__